import styles from './ErrorMessage.module.scss';

export const ErrorMessage = ({ message }: { message: string }) => {
  return <span className={styles.error}>{message}</span>;
};
